'use strict';

const UserCtrl = function ($scope, $rootScope, $state, $stateParams, CRUDService, config, Notification) {

  let currentPage = {
    user: 0,
    center: 0
  },
  totalPages = {
    user: 1,
    center: 1
  },
  initModel = {
    username: "",
    password: "",
    roles: ["ROLE_ASSISTENT"],
    center: []
  };
  $scope.password2 = "";
  $scope.model = initModel;

  $scope.passwords = {
    new: "",
    new2: ""
  };

  if ($stateParams.item) {
    $scope.model = $stateParams.item;
    $scope.model.username = $stateParams.item.coreUser.username;
    $scope.model.roles = $stateParams.item.authorities.map(function (item){
      return item.authority;
    });
    $scope.model.center = $stateParams.item.center.map(function (item){
      return item.uuid;
    });
  }

  $scope.gender = {
    "MALE": 'männlich',
    "FEMALE": 'weiblich'
  };

  $scope.roles = [
    { id: 'ROLE_ASSISTENT', label: 'Assistent' },
    { id: 'ROLE_OFFICER', label: 'Studienbeauftragter' },
    { id: 'ROLE_MONITOR', label: 'Monitor' },
    { id: 'ROLE_ADMIN', label: 'Administrator' },
    { id: 'ROLE_CUSTODIAN', label: 'Datentreuhänder' }
  ];

  function getAll() {
    CRUDService.getAll(config.urls.users + '?projection=default').then(function (data) {
      $scope.users = data._embedded.users;
      totalPages.user = data.page.totalPages;
    });
    CRUDService.getAll(config.urls.center).then(function (data) {
      $scope.center = data._embedded.center;
      totalPages.center = data.page.totalPages;
    });
  }
  getAll();

  $scope.remove = function (item) {
    CRUDService.remove(item._links.self.href).then(
      function () {
        getAll();
      });
  };

  $scope.edit = function (form) {
    $scope.add(form, false);
  };

  $scope.add = function (form, createUser) {
    if (form.$valid) {
      delete $scope.model._links;
      CRUDService.save($scope.model, config.urls.users + '/register').then(function () {
        $scope.model = initModel;
        $state.go('main.settings.user');
        if(createUser && createUser === true){
          Notification.success("Nutzer erfolgreich angelegt.");
        }else{
          Notification.success("Änderungen am Nutzer erfolgreich gespeichert.");
        }
      }, function () {
        Notification.error("Nutzer konnte nicht angelegt werden.");
      });
    }
  };

  $scope.changePw = function (form) {
    if (form.$valid) {
      CRUDService.save(
        {
          "username": $scope.model.uuid,
          "password": $scope.passwords.new
        }, config.urls.users + '/changePw'
      ).then(function () {
        $state.go('main.settings.user');
      }, function () {
        Notification.error('Beim Speichern der Daten ist ein Fehler aufgetreten.');
      });
    }
  };

  $scope.getNextPage = function () {
    if ((currentPage.user + 1) < totalPages.user) {
      currentPage.user++;
      CRUDService.getAll(config.urls.users + '?projection=default', currentPage.user).then(function (data) {
        $scope.users = $scope.users.concat(data._embedded.users);
      });
    }
  };

  $scope.getNextPageCenter = function () {
    if ((currentPage.center + 1) < totalPages.center) {
      currentPage.center++;
      CRUDService.getAll(config.urls.center, currentPage.center).then(function (data) {
        $scope.center = $scope.center.concat(data._embedded.center);
      });
    }
  };
};

UserCtrl.$inject = ['$scope', '$rootScope', '$state', '$stateParams', 'CRUDService', 'config', 'Notification'];

module.exports = UserCtrl;



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/settings/components/form-users/user.js